import React, { Component } from 'react'

import LanguageControllerResponsive from 'modules/Controllers/Language/LanguageControllerResponsive'
import LanguageController from 'modules/Controllers/Language/LanguageController'
import APPURL from 'utils/app/urls'

class LanguageControllerContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.setLanguage(this.props.match.params.lang)
  }

	setLanguage = lang => {
	  this.props.setLanguage(lang)
	  localStorage.setItem('defaultLanguage', lang)
	  let oldURL = this.props.history.location.pathname
	  let newURL = APPURL.getSameURLWithChangedLanguage({ url: oldURL, language: lang })
	  if (oldURL !== newURL) {
	    this.props.history.push(newURL)
	  }
	}

	renderDecider() {
	  if (this.props.responsive) {
	    return (
	      <LanguageControllerResponsive
	        fn={this.setLanguage}
	        selectedLanguage={this.props.match.params.lang}
	        closeMenuOffCanvas={this.props.closeMenuOffCanvas}
	      />
	    )
	  } else {
	    return <LanguageController fn={this.setLanguage} selectedLanguage={this.props.match.params.lang} />
	  }
	}

	render() {
	  return <React.Fragment>{this.renderDecider()}</React.Fragment>
	}
}

export default LanguageControllerContainer



// WEBPACK FOOTER //
// ./src/modules/Controllers/Language/LanguageControllerContainer/LanguageControllerContainer.jsx